import React from 'react'
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import MessageIcon from '@material-ui/icons/Message';
import './Header.css'
import { IconButton } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import { Link, useHistory } from 'react-router-dom';

const Header = ({ backButton }) => {
    const history = useHistory()
    return (
        // BEM <<<<<<<<<<<
        <div className='header'>
            {backButton ? (
                <IconButton onClick={() => history.replace(backButton)}>
                    <ArrowBackIosIcon className='header__icon' fontSize="large" />
                </IconButton>
            ) : (
                    <IconButton>
                        <AccountBoxIcon className='header__icon' color="primary" fontSize="large" />
                    </IconButton>
                )}
            <Link to='/'>
                <img
                    className='header__logo'
                    src='https://1000logos.net/wp-content/uploads/2018/07/tinder-logo.png'
                    alt='tinder logo' />
            </Link>
            <Link to='/chat'>
                <IconButton>
                    <MessageIcon className='header__icon' color="primary" fontSize="large" />
                </IconButton>
            </Link>
        </div>
    )
}

export default Header